import { AnchorTarget } from 'root/src/client/v2/_pages/content/redesign/AnchorTarget';
import { ContentProse } from 'root/src/client/v2/_pages/content/redesign/ContentProse';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'root/src/client/v2/common/components/ui/accordion';
// One FAQ category: an anchored section heading plus a multi-open accordion of its questions. The
// accordion is controlled so a hash deep link or a TOC click can open a specific question (and keep
// others open). Each question carries an `AnchorTarget` so react-scroll lands its heading clear of the
// fixed navbar. Answers render verbatim inside `ContentProse` (neon-cyan links).
export const FaqAccordionSection = ({ section, openItems, onOpenChange }) => (<section className="relative scroll-mt-[88px] pb-10">
		<AnchorTarget id={section.id}/>
		<h2 className="mb-5 font-display text-2xl font-bold text-foreground">{section.sectionTitle}</h2>
		<Accordion type="multiple" value={openItems} onValueChange={onOpenChange} className="space-y-3">
			{section.items.map(item => (<div key={item.id} className="relative scroll-mt-[88px]">
					<AnchorTarget id={item.id}/>
					<AccordionItem value={item.id}>
						<AccordionTrigger>{item.title}</AccordionTrigger>
						<AccordionContent>
							<ContentProse>{item.content}</ContentProse>
						</AccordionContent>
					</AccordionItem>
				</div>))}
		</Accordion>
	</section>);
